import { render, staticRenderFns } from "./ViewSurveyAnswers.vue?vue&type=template&id=13f286dd&scoped=true"
import script from "./ViewSurveyAnswers.vue?vue&type=script&lang=js"
export * from "./ViewSurveyAnswers.vue?vue&type=script&lang=js"
import style0 from "./ViewSurveyAnswers.vue?vue&type=style&index=0&id=13f286dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f286dd",
  null
  
)

export default component.exports